import { useState, useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { TiArrowUpThick, TiArrowDownThick } from "react-icons/ti";
import ServiceSensorDataAlarm from "../../service/Mgt-sensor-data-alarm";
import TableControl from "../../component/table/TableControl";
import { Button, message } from "antd";
import Swal from "sweetalert2";

export default function TableListAlarm(props) {
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    initColumn(props.permission);
  }, [props.permission, props.data]);

  const initColumn = async (permission) => {
    let column = [
      {
        title: "วันที่",
        dataIndex: "date",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => new Date(a.date) - new Date(b.date),
      },
      {
        title: "ข้อความ",
        dataIndex: "msg",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.msg.localeCompare(b.msg),
        render: (_, record) => (
          <>
            {record.trend == "d" ? (
              <TiArrowDownThick style={{ color: "red" }} />
            ) : (
              <TiArrowUpThick style={{ color: "#68e3b0" }} />
            )}
            <span>{record.msg}</span>
          </>
        ),
      },
      {
        title: "ข้อมูล",
        dataIndex: "data",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.data.localeCompare(b.data),
      },
      {
        title: "ข้อมูลก่อนหน้า",
        dataIndex: "prev_data",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.prev_data.localeCompare(b.prev_data),
      },
      {
        title: "สถานี",
        dataIndex: "station_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.station_name.localeCompare(b.station_name),
      },
      {
        title: "เซนเซอร์",
        dataIndex: "sensor_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.sensor_name.localeCompare(b.sensor_name),
      },
      {
        title: "ชื่อพารามิเตอร์",
        dataIndex: "parameter_name",
        align: "center",
        className: "cn allow-search",
        sorter: (a, b) => a.parameter_name.localeCompare(b.parameter_name),
      },
    ];
    if (
      permission.indexOf("update") >= 0 ||
      permission.indexOf("delete") >= 0
    ) {
      column.push({
        title: <AiFillSetting />,
        dataIndex: "action",
        align: "center",
        className: "cell-action",
        render: (_, record) => (
          <>
            <Button
              className="btn-delete-data"
              onClick={() => {
                onDelete(record.id, record.station_name, record.date);
              }}
            >
              <FaTrashAlt />
            </Button>
          </>
        ),
      });
    }

    setColumns(column);
  };

  const onDelete = async (id, stationName, date) => {
    Swal.fire({
      icon: "question",
      title: `ยืนยันการลบการแจ้งเตือน สถานี ${stationName} เวลา ${date}`,
      showCancelButton: true,
      confirmButtonText: `ยืนยัน`,
      cancelButtonText: `ยกเลิก`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await ServiceSensorDataAlarm.delete(id);
        if (result) {
          message.success(
            `ลบการแจ้งเตือน สถานี ${stationName} เวลา ${date} สำเร็จ`
          );
          props.fncSetData(props.data.filter((item) => item.id != result.id));
        }
      }
    });
  };

  return (
    <TableControl
      className={
        "table-dashboard-list-alarm" + (props.className ? props.className : "")
      }
      topRightButton={
        <Button
          className="btn-delete-data"
          onClick={() => {
            Swal.fire({
              icon: "question",
              title: "ยืนยันการลบทั้งหมด",
              showCancelButton: true,
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
            }).then(async (result) => {
              if (result.isConfirmed) {
                let result = await ServiceSensorDataAlarm.deleteAll();
                if (result) {
                  message.success("ลบทั้งหมดสำเร็จ");
                  props.fncSetData([]);
                }
              }
            });
          }}
        >
          ลบทั้งหมด
        </Button>
      }
      rowKey={"id"}
      data={props.data}
      columns={columns}
      dataSet={1}
    />
  );
}
